import httpClient from '../http-client'
import environment from '@/environment'
import adaptPlatformData from '@/services/adapt-platform-data'

export default data => {
    const platformData = adaptPlatformData(data)
    if (environment.isProduction) {
        return httpClient.post('/platforms', platformData)
    } else {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    data: {
                        // eslint-disable-next-line
                        receipt_id: 'test',
                    },
                })
            }, 4000)
        })
    }
}
